import { useContext } from 'react'
import { Grid } from '@mui/material';
import AccordionPanel from 'view/FrontEnd/Project/components/AccordionPanel';
import { ProviderExpenseActual } from './FundExpenseActualForm';
import TableActualExpenseSectionProject from './TableActualExpenseSectionProject';
import TableActualFundAdd from './TableActualFundAdd';


const TableActualExpenseSection = () => {
    const {
        lstExpense,
    } = useContext(ProviderExpenseActual);

    return (
        <Grid container spacing={2}>
           {
                lstExpense.map((item, indexSection) => {
                    let keyCellMuseum = "inputTotal_" + item.nSectionId + "_" + indexSection;
                    return (
                        <Grid key={keyCellMuseum} item xs={12}>
                            <AccordionPanel header={item.sSectionName} >
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        {
                                            item.nSectionId === 39 ?
                                                <TableActualFundAdd keyId={"key_" + item.nSectionId}/>
                                                :
                                                <TableActualExpenseSectionProject keyId={"key_" + item.nSectionId} item={item} />
                                        }
                                    </Grid>
                                </Grid>
                            </AccordionPanel>
                        </Grid>
                    )
                })
            }
        </Grid>
    )
}

export default TableActualExpenseSection

